(function () {
  function init(root) {
    if (!root || root.dataset.inited === "1") return;
    root.dataset.inited = "1";

    var head = root.querySelector(".acc-head");
    var body = root.querySelector(".acc-body");
    var icon = root.querySelector(".acc-icon");
    var text = root.querySelector(".acc-text");
    var btn = root.querySelector("[data-readmore]");
    if (!head || !body || !icon || !text || !btn) return;

    var lines = parseInt(root.getAttribute("data-lines") || "8", 10);
    text.style.setProperty("--clamp", lines);

    // Hide readmore if not needed
    requestAnimationFrame(function () {
      var needsClamp = text.scrollHeight > text.clientHeight + 5;
      if (!needsClamp) btn.style.display = "none";
    });

    head.addEventListener("click", function () {
      var expanded = head.getAttribute("aria-expanded") === "true";
      head.setAttribute("aria-expanded", String(!expanded));
      body.style.display = expanded ? "none" : "";
      icon.textContent = expanded ? "+" : "–";
    });

    btn.addEventListener("click", function () {
      var isClamped = text.classList.contains("is-clamped");
      if (isClamped) {
        text.classList.remove("is-clamped");
        btn.textContent = "Show less";
      } else {
        text.classList.add("is-clamped");
        btn.textContent = "Show more";
        text.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  }

  function scan() {
    document.querySelectorAll(".additional-content-product-page[data-acc]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", scan);

  // For theme editor / ajax updates
  document.addEventListener("shopify:section:load", scan);
})();
